
import React, {useState} from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'
import { useDispatch,useSelector } from 'react-redux'
import {translation} from "../I18n/i18n"

function Navbar() {

    const lang = useSelector(state => state.languageReducer.language)
    const dispatch = useDispatch()

    const [active,setActive] = useState(1)

    //FOR LIGHT VERSION USE THIS ONE
    return(
        <div className='navs__content__basic'>
            <Link to='/' onClick={()=>setActive(2)} className={active===2?'active_navs':''}>{translation(lang,"Accueil")}</Link>
            <Link to='/catalogue' onClick={()=>setActive(3)} className={active===3?'active_navs':''}>{translation(lang,"Catalogue")}</Link>
            <Link to='/contact' onClick={()=>setActive(4)} className={active===4?'active_navs':''}>{translation(lang,"Contact")}</Link>
            <div className='box-btn'>
              <div className='btn btn-fr' onClick={(() => dispatch({ type: 'fr' }))}><img src='../france.svg' alt='fr' width='30' heigh='20'></img></div>
              <div className='btn btn-en' onClick={(() => dispatch({ type: 'en' }))}><img src='../uk.svg' alt='fr' width='30' heigh='20'></img></div>
            </div>
        </div>
        )

    }

export default Navbar;
